import * as React from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

import { galleryContainer, galleryControls } from "./product-gallery.module.css"
import UnavailableBadge from "./unavailable-badge"

const ProductGallery = ({ images, available }) => {
  const [displayedImage, setDisplayedImage] = React.useState(images[0])

  const handlePrevious = () => {
    const currentIndex = images.indexOf(displayedImage)
    if (currentIndex !== 0) setDisplayedImage(images[currentIndex-1]) 
  }
  const handleNext = () => {
    const currentIndex = images.indexOf(displayedImage)
    if (currentIndex+1 !== images.length) setDisplayedImage(images[currentIndex+1]) 
  }
  return (
    <div className={galleryContainer}>
      {!available && <UnavailableBadge />}
      <GatsbyImage
        alt={"Product Image"}
        image={displayedImage.gatsbyImageData}
        placeholder="none"
        loading={"lazy"}
        style={{height: "100%", width: "100%",}}
        imgStyle={{ objectFit: "contain"}}
      />
      {/* <img src={displayedImage.originalSrc} alt="" /> */}
      {images.length > 1 &&
        <footer className={galleryControls}>
          <button onClick={handlePrevious}><img src="/left-gallery-arrow.svg" alt="left" /></button>
          <p>({images.indexOf(displayedImage)+1}/{images.length})</p>
          <button onClick={handleNext}><img src="/right-gallery-arrow.svg" alt="right" /></button>
        </footer>
      }

    </div>
  )
}

export default ProductGallery